<template>
  <div class="message">
    <div class="box">
      <div class="title">
        <p>修改信息</p>
        <i class="el-icon-close" @click="ishidefun"></i>
      </div>
      <div class="con">
        <el-form :model="ruleForm" ref="ruleForm" label-width="82px">
          <el-form-item label="上传图片" class="imgurl" prop="cover">
            <div v-if="ruleForm.cover" class="el-upload-list--picture-card">
              <img :src="ruleForm.cover" class="avatar" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-delete" @click="handleRemove">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <el-upload
              v-else
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="request"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="客户名称" prop="name1">
            <el-input
              v-model="ruleForm.name1"
              :placeholder="userinfo.name1"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系负责人" prop="niceName">
            <el-input
              v-model="ruleForm.niceName"
              :placeholder="userinfo.niceName"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              :placeholder="userinfo.phone"
            ></el-input>
          </el-form-item>
          <el-form-item class="btnbox">
            <el-button type="primary" @click="submitForm"> 立即修改 </el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import means from './message.js'
const service = require('@/assets/js/request')
const env = process.env

export default {
  name: 'message',
  data () {
    return {
      files: {
        imageUrl: '',
        file: '',
        upFileData: {}
      },
      ruleForm: {
        cover: this.$store.state.user.userInfo.avatars,
        name1: this.$store.state.user.userInfo.name1,
        niceName: this.$store.state.user.userInfo.niceName,
        phone: this.$store.state.user.userInfo.phone
      }
    }
  },
  computed: {
    userinfo () {
      return this.$store.state.user.userInfo
    },
    action () {
      return env.REQUERT_URL + '/api/Userinfo/uploadImg'
    }
  },
  methods: {
    request () {
      let formData = new FormData()
      formData.append('token', localStorage.getItem('token'))
      formData.append('file', this.files)
      formData.append('path', 'message')
      formData.append('type', 'image')
      service
        .upfile({
          url: 'uploadImg',
          params: formData
        })
        .then((res) => {
          if (res.code === '2001') {
            this.ruleForm.cover = env.REQUERT_URL + 'uploads' + res.data
          }
        })
        .catch((err) => {
          service.error(err, {
            that: this
          })
        })
    },
    handleRemove () {
      this.ruleForm.cover = ''
    },
    beforeAvatarUpload (file) {
      this.files = file
      const isJPG = file.type === 'image/jpeg' || 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    submitForm () {
      means.updateUserInfo(this)
      this.$router.go()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    ishidefun () {
      this.$emit('ishidefun', true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./message";
</style>



// WEBPACK FOOTER //
// src/components/customer/message/message.vue